import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId } from "../../../constants";
import AreaChooser from "../../choosers/AreaChooser";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import ProjectedFundingGapsBySectorTable from "./ProjectedFundingGapsBySectorTable";

const ProjectedFundingGapsBySectorTableWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  return (
    <DataViewerFrame
      reference="Table 1.2"
      title="Projected Funding Gaps by Sector, 2020 and 2025"
      subtitle="Segmented by Sector"
      filters={[
        <AreaChooser
          id="table-1-2"
          areas={props.database.areas}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme1.projectedFundingGapsBySectorTable",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          area: props.database.areas[areaId].area
        });
      }}
    >
      <ProjectedFundingGapsBySectorTable data={props.data} areaId={areaId} />
    </DataViewerFrame>
  );
};

ProjectedFundingGapsBySectorTableWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ProjectedFundingGapsBySectorTableWidget;
